(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["billboard"] && !Shopify.designMode) return;
  try {
    
          

        const videos = document.querySelectorAll('.cf-billboard-media--video')
        videos.forEach(video => {
            const observer = new IntersectionObserver(e => {
            e[0].isIntersecting ? video.play() : video.pause()
            }, {
            threshold: 0.25
            })
            observer.observe(video)
        })
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection)

    const url = productRecommendationsSection.dataset.url

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cf-recos');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML 
          
          const recoNode = document.querySelector('.cf-reco-cards_carousel-viewport')
          const options = { 
              loop: false,
              dragFree: true,
              watchDrag: e => e.scrollSnapList().length === 1 ? false : true    
          }
          let recoCarousel = EmblaCarousel(recoNode, options)
          const prevBtn = recoCarousel.rootNode().querySelector('.cf-cards_carousel-prev')
          const nextBtn = recoCarousel.rootNode().querySelector('.cf-cards_carousel-next')
          const counter = recoCarousel.rootNode().querySelector('.cf-cards_carousel-count')
          prevBtn.addEventListener('click', recoCarousel.scrollPrev, false)
          nextBtn.addEventListener('click', recoCarousel.scrollNext, false)

          const updateRecoCarousel = (carousel) => {
            if(recoCarousel.rootNode().hasAttribute('center-visible')) {
                recoCarousel.containerNode().style.justifyContent = recoCarousel.scrollSnapList().length === 1 ? 'center' : 'flex-start'
            }

            // Prev Next
            if (recoCarousel.canScrollPrev()) prevBtn.removeAttribute('disabled')
            else prevBtn.setAttribute('disabled', 'disabled')

            if (recoCarousel.canScrollNext()) nextBtn.removeAttribute('disabled')
            else {
                nextBtn.setAttribute('disabled', 'disabled')
                counter.classList.remove('cf-cards_carousel-count--visible')
            }

            // Progress Bar
            const selectedSnap = recoCarousel.selectedScrollSnap() + 1
            const snapCount = recoCarousel.scrollSnapList().length
            const progressBar = counter.querySelector('.cf-cards_carousel-count-progress')
            const progress = Math.max(0, Math.min(100, selectedSnap / snapCount) * 100)
            progressBar.setAttribute('style', `--progress: ${selectedSnap === 1 ? 0 : progress}%`)
          }
          recoCarousel
              .on('select', updateRecoCarousel)
              .on('reInit', updateRecoCarousel)
              .on('select', () => { 
                  // Only show counter if more than two snaps (one click of the arrow).
                  if(recoCarousel.scrollSnapList().length > 2 && recoCarousel.canScrollNext()) counter.classList.add('cf-cards_carousel-count--visible') 
              })
              .on('settle', () => counter.classList.remove('cf-cards_carousel-count--visible'))
              .on('resize', () => counter.classList.remove('cf-cards_carousel-count--visible'))

          updateRecoCarousel(recoCarousel)

          const recoContainer = document.querySelector('.cf-reco-container')
          recoContainer.setAttribute('aria-hidden', 'false')

        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  const productRecommendationsSection = document.querySelector('.cf-recos')
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'})

  observer.observe(productRecommendationsSection)


  } catch(e) { console.error(e); }
})();
})();
